import { z } from '../zod';
import { FieldValidationSchema } from '../charge/';

export const AttendeeDetailsResponseShape = {
  name: z.string().optional().meta({ description: "The attendee's name." }),
  email: z.string().optional().meta({ description: "The attendee's email address." }),
  answers: z.array(FieldValidationSchema).optional().meta({
    description:
      "The attendee's answers to the event's attendee questions, in the same shape as the booking's `fields`. `reference` matches the question's reference. Name and email are not repeated here.",
  }),
  flagged: z.boolean().optional().meta({
    description:
      "True when the event's email domain rule flagged this attendee for the seller to review. It stays true after review; see `reviewedAt`.",
  }),
  reviewedAt: z.iso.datetime().optional().meta({
    description:
      'ISO-8601 UTC timestamp the seller marked this flagged attendee as reviewed. The booking counts as `flagged` while any flagged attendee has none.',
  }),
};
